import React, { useState } from "react";
import Select from "@atlaskit/select";
import Button from "@atlaskit/button/new";
import AceEditor from "react-ace";
import "ace-builds/webpack-resolver";
import "ace-builds/src-noconflict/mode-json";
import "ace-builds/src-noconflict/mode-text";
import "ace-builds/src-noconflict/theme-dawn";
import { getAceEditorTheme } from "../../common/utils/aceEditorTheme";
import { getFormatted } from "../../common/utils/formatter";

const EncodeDecodePage = () => {
  const [data, setData] = useState("");
  const [selected, setSelected] = useState("");
  const [result, setResult] = useState("");
  const [resultMode, setResultMode] = useState("text");
  const onChangeInput = (newValue) => {
    setData(newValue);
  };

  const options = [
    { label: "URL Encode", value: "URL Encode" },
    { label: "URL Decode", value: "URL Decode" },
    { label: "Base 64 Encode", value: "Base 64 Encode" },
    { label: "Base 64 Decode", value: "Base 64 Decode" },
    { label: "Decode JWT", value: "JWT Decode" },
    { label: "Convert a JavaScript object to a JSON string", value: "JSON Stringify" },
    { label: "Convert a CSV to a JSON string", value: "CSV JSON Stringify" },
    { label: "Convert a TSV to a JSON string", value: "TSV JSON Stringify" },
  ];
  const onSelect = (item) => {
    setSelected(item.value);
  };
  const setResultValue = (value, mode = "text") => {
    setResult(value);
    setResultMode(mode);
  };
  const onClick = () => {
    switch (selected) {
      case "URL Encode":
        setResultValue(encodeURI(data));
        break;
      case "URL Decode":
        setResultValue(decodeURI(data));
        break;
      case "Base 64 Encode":
        setResultValue(btoa(data));
        break;
      case "Base 64 Decode":
        try {
          setResultValue(base64Decode(data));
        } catch (error) {
          setResultValue(error.message);
        }
        break;

      case "JWT Decode":
        try {
          setResultValue(decodeJwt(data), "json");
        } catch (error) {
          setResultValue(error.message);
        }
        break;

      case "JSON Stringify":
        setResultValue(getFormatted(data), "json");
        break;
      case "CSV JSON Stringify":
        setResultValue(csvToJson(data), "json");
        break;
      case "TSV JSON Stringify":
        setResultValue(tsvToJson(data), "json");
        break;
      default:
        break;
    }
  };
  const csvToJson = (csv) => {
    var lines = csv.split("\n");

    var result = [];

    var headers = lines[0].split(",");

    for (var i = 1; i < lines.length; i++) {
      var obj = {};
      var currentline = lines[i].split(",");

      for (var j = 0; j < headers.length; j++) {
        obj[headers[j]] = currentline[j];
      }

      result.push(obj);
    }

    //return result; //JavaScript object
    return JSON.stringify(result); //JSON
  };

  const base64Decode = (value) => {
    if (!value) {
      return "";
    }
    const sanitized = value
      .replace(/[\r\n\s]/g, "")
      .replace(/-/g, "+")
      .replace(/_/g, "/");
    const padded = sanitized + "=".repeat((4 - (sanitized.length % 4)) % 4);
    try {
      return atob(padded);
    } catch (error) {
      throw new Error("Invalid Base64 input");
    }
  };
  const decodeJwt = (token) => {
    if (!token) {
      throw new Error("JWT is required");
    }
    const parts = token.split(".");
    if (parts.length < 2) {
      throw new Error("JWT must include at least header and payload");
    }
    const [headerSegment, payloadSegment] = parts;

    const decodedHeader = parseJwtSegment(headerSegment, "header");
    const decodedPayload = parseJwtSegment(payloadSegment, "payload");

    return JSON.stringify(
      {
        header: decodedHeader,
        payload: decodedPayload,
      },
      null,
      2
    );
  };

  const parseJwtSegment = (segment, label) => {
    try {
      const decoded = base64UrlDecode(segment);
      return JSON.parse(decoded);
    } catch (error) {
      throw new Error(`Unable to parse JWT ${label}`);
    }
  };

  const base64UrlDecode = (segment) => {
    const normalized = segment.replace(/-/g, "+").replace(/_/g, "/");
    const padded = normalized + "=".repeat((4 - (normalized.length % 4)) % 4);
    const decoded = atob(padded);
    try {
      return decodeURIComponent(
        decoded
          .split("")
          .map((char) => "%" + ("00" + char.charCodeAt(0).toString(16)).slice(-2))
          .join("")
      );
    } catch (error) {
      return decoded;
    }
  };
  const tsvToJson = (tsv) => {
    var lines = tsv.split("\n");

    var result = [];

    var headers = lines[0].split("\t");

    for (var i = 1; i < lines.length; i++) {
      var obj = {};
      var currentline = lines[i].split("\t");

      for (var j = 0; j < headers.length; j++) {
        obj[headers[j]] = currentline[j];
      }

      result.push(obj);
    }

    //return result; //JavaScript object
    return JSON.stringify(result); //JSON
  };

  return (
    <div className="ihub-public-main">
      <h3>Encode / Decode</h3>
      <AceEditor
        className="ihub-encode-input-editor"
        mode="text"
        theme={getAceEditorTheme()}
        name="encode-decode-input"
        value={data}
        width="100%"
        height="200px"
        onChange={onChangeInput}
        showPrintMargin={false}
        editorProps={{ $blockScrolling: true }}
        setOptions={{ useWorker: false }}
      />
      <p></p>
      <Select
        className="ihub-coder-select"
        options={options}
        spacing="compact"
        isRequired={false}
        onChange={onSelect}
        styles={{ position: "relative", zIndex: "100" }}
      />{" "}
      <p></p>
      <Button onClick={onClick}>Convert</Button>
      <p></p>
      <p>
        <b>Result</b>
      </p>
      <AceEditor
        className="ihub-encode-result-editor"
        mode={resultMode}
        theme={getAceEditorTheme()}
        showPrintMargin={false}
        name="encode-decode-result"
        value={result}
        width="100%"
        height="500px"
        readOnly
        showGutter={false}
        highlightActiveLine={false}
        editorProps={{ $blockScrolling: true }}
        setOptions={{ useWorker: false }}
      />
    </div>
  );
};

export default EncodeDecodePage;
